import React, { useState, useEffect, Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
import TopBackButton from '@/component/common/top-back-button';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Banner from '@/component/common/banner';
import Stack from '@mui/material/Stack';
import { boardList, boardListProps, resNoticeListProps } from '@/api/server/board/read';
import { langSessionStorage } from '@/lib/storage';
import ErrorRes from '@/api/server/ErrorRes';

export default function EventPage() {
  const navigate = useNavigate();
  const [list, setList] = useState<resNoticeListProps[]>([]);
  useEffect(() => {
    (async () => {
      const paylaod: boardListProps = {
        board_type: 'event',
        search_lang: langSessionStorage().lang,
      };
      const re = await boardList(paylaod);
      if (re.ret_code !== 200) {
        ErrorRes({ code: re.ret_code, msg: re.msg });
        return;
      }
      setList(re.data.list);
    })();

    return () => {};
  }, []);

  return (
    <Container
      maxWidth="sm"
      sx={{
        minHeight: '812px',
        height: '100vh',
        position: 'relative',
      }}
    >
      <TopBackButton
        title="이벤트"
        boxProps={{
          mb: 4,
        }}
      />
      <Stack gap={1.5}>
        {/* <Banner title="회원가입 이벤트" category="EVENT" /> */}
        {list.length > 0
          ? list.map((item: resNoticeListProps) => (
              <Fragment key={item.board_id}>
                {/* 종료된 이벤트 */}
                {item.event_status === 'es02' ? (
                  <Banner
                    title={item.title}
                    category="EVENT"
                    src={item.asset_url}
                    closed
                    onClick={() => {
                      navigate(`/eventDetail/${item.board_id}`);
                    }}
                  />
                ) : (
                    <Banner
                      title={item.title}
                      category="EVENT"
                      src={item.asset_url}
                      onClick={() => {
                        navigate(`/eventDetail/${item.board_id}`);
                      }}
                    />
                )}
              </Fragment>
            ))
          : ''}
      </Stack>
    </Container>
  );
}
